import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./circleButton.styles";
export function CircleButton({ children, isDisabled, isSelected, onClick, }) {
    return (_jsx(S.Layout, { "$isDisabled": isDisabled, "$isSelected": isSelected, onClick: onClick, children: children }));
}
